/* eslint-disable max-len */
import { get } from 'lodash';
import { object, string } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import './budget-strip-2023-header.module.css';

const BudgetStrip2023Header = ({ sponsors, type }) => {
  // const presentingSponsors = sponsors.filter(({ presenting }) => presenting);
  const associateSponsors = sponsors.filter(({ associate }) => associate);

  const calculateTimeLeft = () => {
    const difference = +new Date('2023-02-01T11:00:00+05:30') - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  };
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
  });

  return (
    <div styleName={type === 'story-page' ? 'budget-strip-story-page' : 'budget-strip-story-page'}>
      <div className="container" styleName="container">
        <div styleName="pn-budgetStrip-wrapper">
          <div styleName="budget-image-container">
            <a href={`/budget-2023?src=${type === 'story-page' ? 'budget_story' : 'budget_home'}`}>
              <img
                src="https://images.assettype.com/bloombergquint/2023-01/76ce29bb-39c2-45b8-8634-99368625b71c/Budget_2023.png"
                alt="Budget Strip 2023 Logo"
                width="272px"
                height="73px"
              />
            </a>
          </div>
          <img
            src="https://images.assettype.com/bloombergquint/2023-01/8129a4b8-8e0d-42e9-93cc-789f511170e0/Mask_Group_16280_2x.png"
            alt="Budget Wave Logo"
            width="300px"
            height="60px"
            className="desktop-only"
          />
          <div styleName="timer-with-sponsors">
            <div
              styleName={
                type === 'story-page'
                  ? 'right-side-container-story-page'
                  : 'right-side-container-story-page'
              }
            >
              {timeLeft?.days || timeLeft?.hours || timeLeft?.minutes ? (
                <div
                  styleName={
                    type === 'story-page' ? 'timer-wrapper-story-page' : 'timer-wrapper-story-page'
                  }
                >
                  <div styleName="timer-text">STARTS IN</div>
                  <div styleName="timer">
                    {timeLeft.days}&nbsp;Days&nbsp;:&nbsp;
                    {timeLeft.hours}&nbsp;Hrs&nbsp;:&nbsp;
                    {timeLeft.minutes}&nbsp;Mins&nbsp;
                  </div>
                </div>
              ) : timeLeft.seconds ? (
                <div
                  styleName={
                    type === 'story-page' ? 'timer-wrapper-story-page' : 'timer-wrapper-story-page'
                  }
                >
                  <div styleName="timer-text">STARTS IN</div>
                  <div styleName="timer">{timeLeft.seconds}&nbsp;Seconds&nbsp;</div>
                </div>
              ) : null}
              <div styleName="container-with-text">
                <span>Associate Sponsors</span>
                <div>
                  {associateSponsors.map(({ url, width, height, altText, href }) => (
                    <a key={altText} href={href} target="_blank" rel="noreferrer">
                      <img src={url} alt={altText} width={width} height={height} />
                    </a>
                  ))}
                </div>
              </div>
              {/* <div styleName="container-with-text">
              <span>Presenting Sponsors</span>
              <div>
                {presentingSponsors.map(({ url, width, height, altText, href }) => (
                  <a key={altText} href={href} target="_blank" rel="noreferrer">
                    <img src={url} alt={altText} width={width} height={height} />
                  </a>
                ))}
              </div>
            </div> */}
            </div>
            {/* <div styleName="container-without-text">
            <a href="https://arvind.nnnow.com/" target="_blank" rel="noreferrer">
              <img src="/images/arvind-sponsor.png" alt="Arvind" width="72px" />
            </a>
            <a
              href="https://ad.doubleclick.net/ddm/trackclk/N733098.3002119BLOOMBERGQUINT/B27205974.327276152;dc_trk_aid=519614842;dc_trk_cid=165932826;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd="
              target="_blank"
              rel="noreferrer"
            >
              <img src="/images/icicilogo.png" alt="ICICI Prudential Mutual Fund" />
            </a>
            <a href="https://arvind.nnnow.com/" target="_blank" rel="noreferrer">
              <img src="/images/arvind-sponsor.png" alt="Arvind" width="72px" />
            </a>
          </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};
BudgetStrip2023Header.propTypes = {
  sponsors: object,
  type: string,
};

const mapStateToProps = (state) => ({
  sponsors: get(state, ['qt', 'config', 'publisher', 'budget_2023_sponsors'], []),
});

export default connect(mapStateToProps)(BudgetStrip2023Header);
